import { render, staticRenderFns } from "./ItemGrid.vue?vue&type=template&id=2dcb8128&"
import script from "./ItemGrid.vue?vue&type=script&lang=js&"
export * from "./ItemGrid.vue?vue&type=script&lang=js&"
import style0 from "./ItemGrid.vue?vue&type=style&index=0&id=2dcb8128&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports